import React from 'react';
import { PreviewStoreProvider } from 'gatsby-source-prismic';
import { ThemeProvider } from '../../contexts/ThemeContext';
import IEBanner from '../IEBanner/IEBanner';
import useIsIE11 from '../../hooks/useIsIE11';

export default function Root({ children }) {
    const isIE11 = useIsIE11();
    return (
        <ThemeProvider>
            {children}
            {isIE11 && <IEBanner />}
        </ThemeProvider>
    );
}
